import { FolderOutlined }       from '@ant-design/icons';
import { TeamOutlined }         from '@ant-design/icons';
// TODO après la démo : décommenter ces imports et les entrées Facturation et Paramètres plus bas.
// import { SettingOutlined }      from '@ant-design/icons';
// import { DollarCircleOutlined } from '@ant-design/icons';
import { AccessKey }            from '@/stores/accessStore';
import { SUBSCRIPTION_PATH }    from '@/routes/private/billingRoute';
import { SETTINGS_PATH }        from '@/routes/private/settingsRoute';
// import { localizeUi }           from '@/helpers/localizeUi';
import ProjectModel             from './models/services/map/ProjectModel';
import UserModel                from './models/services/account/UserModel';

// Ces deux entrées ne mènent aujourd'hui qu'à l'abonnement : sans accès à la facturation, elles
// n'ouvriraient qu'un écran vide.
export const NAVIGATION_ACCESS: Record<string, AccessKey> = {
	[SETTINGS_PATH]: 'billing',
	[SUBSCRIPTION_PATH]: 'billing',
};

export default [
	{ label: ProjectModel.localize('plural'), icon: <FolderOutlined />, link: '/' },
	{ label: UserModel.localize('plural'), icon: <TeamOutlined />, link: UserModel.pagePath('splitView') },
	// TODO après la démo : menus Facturation et Paramètres masqués le temps de la démo.
	// { label: localizeUi('section.billing'), icon: <DollarCircleOutlined />, link: SUBSCRIPTION_PATH },
	// { label: localizeUi('section.settings'), icon: <SettingOutlined />, link: SETTINGS_PATH },
];
